document.addEventListener("DOMContentLoaded", function(event) {
    let sticky_header = document.querySelector('sticky-header');
    let announcement_section = document.querySelector('.announcement-bar-section');

    if(announcement_section) {
        if(sticky_header) {
            if(sticky_header.classList.contains('ontop')) {
              if (window.innerWidth < 1024) {
                sticky_header.style.paddingTop = '50px';
              } else {
                sticky_header.style.paddingTop = '30px';
              }     
            } else {
                sticky_header.style.paddingTop = '5px';
            } 
        }
    }

    window.addEventListener('scroll', function(event) {
        let sticky_header = document.querySelector('sticky-header');
        let announcement_section = document.querySelector('.announcement-bar-section');
        
        if(announcement_section) {
            if(sticky_header) {
                if(sticky_header.classList.contains('ontop')) {
                    if (window.innerWidth < 1024) {
                      sticky_header.style.paddingTop = '50px';
                    } else {
                      sticky_header.style.paddingTop = '30px';
                    }
                } else {
                    sticky_header.style.paddingTop = '5px';
                }
            } 
        }
    });
});